<template>
  <el-dialog v-model="visible" title="LOT 수량 배분" width="500px" destroy-on-close>
    <el-alert
      v-if="lot"
      :title="`${lot.lot_number} - 잔여수량: ${lot.remaining_quantity} ${lot.unit}`"
      type="info"
      :closable="false"
      style="margin-bottom: 20px"
    />

    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="메인오더" prop="main_request_id">
        <el-select
          v-model="form.main_request_id"
          placeholder="메인오더 선택"
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="mr in mainRequests"
            :key="mr.id"
            :label="`${mr.request_number} - ${mr.brand_name}`"
            :value="mr.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="배분수량" prop="quantity">
        <el-input-number
          v-model="form.quantity"
          :min="0"
          :max="lot?.remaining_quantity"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="비고">
        <el-input v-model="form.remarks" type="textarea" :rows="2" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="visible = false">취소</el-button>
      <el-button type="primary" @click="handleSubmit">배분</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axiosInstance from '@/api/axios'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  lot: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'saved'])

const visible = ref(props.modelValue)
const formRef = ref(null)
const mainRequests = ref([])

const form = reactive({
  main_request_id: null,
  quantity: 0,
  remarks: ''
})

const rules = {
  main_request_id: [{ required: true, message: '메인오더를 선택하세요', trigger: 'change' }],
  quantity: [{ required: true, message: '수량을 입력하세요', trigger: 'blur' }]
}

const fetchMainRequests = async () => {
  try {
    const response = await axiosInstance.get('production/main-requests/', {
      params: { status: 'IN_PRODUCTION' }
    })
    mainRequests.value = response.data.results || response.data
  } catch (error) {
    console.error('Failed to fetch main requests:', error)
  }
}

const handleSubmit = async () => {
  await formRef.value.validate()

  if (form.quantity > props.lot?.remaining_quantity) {
    ElMessage.error('잔여수량을 초과할 수 없습니다.')
    return
  }

  try {
    await axiosInstance.post(`material-lots/${props.lot.id}/allocate/`, form)
    ElMessage.success('수량이 배분되었습니다.')
    emit('saved')
    visible.value = false
  } catch (error) {
    ElMessage.error('배분에 실패했습니다.')
    console.error(error)
  }
}

watch(() => props.modelValue, (val) => {
  visible.value = val
  if (val) {
    form.main_request_id = null
    form.quantity = 0
    form.remarks = ''
  }
})

watch(visible, (val) => {
  emit('update:modelValue', val)
})

onMounted(() => {
  fetchMainRequests()
})
</script>
